module.exports = {
  param2Obj(url) {
    const obj = {};
    if (url && url.indexOf("?") >= 0) {
      const params = url.split("?")[1].split("&");
      params.map((item) => (obj[item.split("=")[0]] = item.split("=")[1]));
    }
    return obj;
  },
};
